var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailIconGreen = function SvgEmailIconGreen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C9FFE8",
    fillRule: "evenodd",
    d: "M2.573 2.742a.6.6 0 0 0-.6.6v9.538a.6.6 0 0 0 .6.6h15.03a.6.6 0 0 0 .6-.6V3.342a.6.6 0 0 0-.6-.6H2.572Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    d: "M1.194 1.193a.6.6 0 0 0-.6.6v9.538a.6.6 0 0 0 .6.6H16.434a.389.389 0 0 0 .39-.389V1.793a.6.6 0 0 0-.6-.6H1.193Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    d: "M1.441 1.193 8.71 8.111l7.268-6.918M6.933 6.562 1.057 11.93M10.486 6.562l5.876 5.369"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailIconGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "EmailIconGreen.0f77633a708d23f501aecb4ba3360dd3.svg";